<template id="page" >
  <div >
    <h1 class="mobiTitle white lg content" id="contentTitle">
      {{$t("main_title")}}
    </h1>
    <div class="main_wrap">
      <div v-if="$props.main.isLoad === false">
        <div class="spinnerC">
          <svg class="spinner" viewBox="0 0 50 50">
            <circle
              class="path"
              cx="25"
              cy="25"
              r="20"
              fill="none"
              stroke-width="5"
            ></circle>
          </svg>

        </div>
        
      </div>
      <div v-if="$props.main.isLoad === true">
        <div class="mobiSection" v-for="hot in $props.main.subcategory" :key="hot.key">
          <div class="mobiSection__header">
            <h2 class="mobiTitle md">
              <img class="mobiIcon" :src="IconHotpick_Mobif" alt="" />
              <span class="text_color">{{ $t("hotpicks") }} - 
                <span v-if="lang_Mobif !== 'english'">{{ hot[`title_${lang_Mobif}`] }}</span>
                <span v-if="lang_Mobif === 'english'">{{ hot.subcategory }}</span>
              </span>
            </h2>
            <div class=" link right">
              <router-link :to="{path: 'hotpicks', query: { q: hot.subcategory } }" class="browse_link"> {{$t("view_more")}} ></router-link>
            </div>
          </div>
          <div class="mobiSection__content">
            <div class="row mobislider" ref="hotPicksCarousel">
              <div v-for="mobif in $props.main.hotpicks[hot.subcategory]" :key="mobif.key" class="col-12 col-md-4 col-lg-4 col-sm-6 mobiVideoExpand">
                <router-link class="mobiVideo" :to="{name: 'DetailPage', params: { id: mobif.content_id } }"  v-if="mobif.subcategory === hot.subcategory">
                    <div class="mobiVideo__thumb">
                      <img class="img_wrp" :src="mobif.cover_img" alt="" />
                    </div>
                    <div data-v-238dec4a="" class="playBtn"><span data-v-238dec4a=""></span></div>
                    <div class="mobiVideo__info">
                        <!-- <h3 class="mobiTitle sm text_color">{{ mobif.content_name }}</h3> -->
                        <span v-if="lang_Mobif !== 'english'">
                          <h3 class="mobiTitle sm" v-if="mobif[`cont_name_${lang_Mobif}`] !== ''">{{ mobif[`cont_name_${lang_Mobif}`] }}</h3>
                          <h3 class="mobiTitle sm" v-else>{{ mobif[`cont_name_english`] }}</h3>
                        </span>
                        <span v-else>
                          <h3 class="mobiTitle sm">{{ mobif[`cont_name_english`] }}</h3>
                        </span>
                      <div>
                        <star-rating :inline="true" :star-size="16" :read-only="true" :increment="0.01" :show-rating="false" :border-width="2" border-color="#feb801" inactive-color="transparent" active-color="#ffb902" :rounded-corners= "false" :star-points="[23,2,14,17,0,19,10,34,7,50,23,43,38,50,36,34,46,19,31,17]"
                        :rating="Number(mobif.rating)"></star-rating>
                      </div>
                    </div>
                  </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters, mapActions } from "vuex";
import Flickity from "flickity";
import StarRating from 'vue-star-rating';
// Vue.component("star-rating", VueStarRating.default);
export default {
  data() {
    return {
      flickityOptions: {
        dragThreshold: 50,
        initialIndex: 0,
        prevNextButtons: true,
        pageDots: false,
        cellAlign: "left",
        resize: true,
        hash: true,
        percentPosition: false,
        imagesLoaded: true,
        groupCells: true
      },
      stageDragging: false
    };
  },
  components:{
    StarRating
  },
  props: ["main"],
  computed: mapGetters([
    // "subCate_Mobif",
    // "allData_Mobif",
    "IconHotpick_Mobif",
    "IconPopular_Mobif",
    "lang_Mobif",
    "country_Mobif"
    // "homeSliderContentLoaded",
    // "hpisLoad_Mobif"
  ]),
  mounted() {
    // this.fetchHomeHotPick_Mobif();
    if (this.$props.main.hotpicks.length !== undefined) {
      this.initHotPicksSlider();
    }
  },
  updated() {
    if (this.$props.main.dataLoaded === true) {
      this.initHotPicksSlider();
    }
  },
  methods: {
    // ...mapActions(["fetchHomeHotPick_Mobif"]),
    initHotPicksSlider() {
      setTimeout(() => {
        this.$nextTick(() => {
          let i = 0;
          this.$refs.hotPicksCarousel.map(flktyElm => {
            let flktyBName = `homeHotPlicksSliderflkty${i}`;
            i++;

            flktyBName = new Flickity(flktyElm, this.flickityOptions);
            flktyBName.on("dragStart", function() {
              this.stageDragging = true;
            });
            flktyBName.on("dragEnd", function() {
              this.stageDragging = false;
            });
          });
        });
      }, 0);
    }
  }
};
</script>

<style scoped lang="scss">
.mobiflix .mobiSection {
  overflow-x: hidden;
}
.main_title {
  color: black;
}

.browse_link {
  color: black;
  display: block;
}
.mobiflix .mobislider {
  &:hover .mobiVideoExpand {
    opacity: 0.3;
  }
  .mobiVideoExpand:hover {
    transform: scale(1.2);
    opacity: 1;
  }
  &::before,
  &::after {
    display: none;
  }
}
.mobiVideoExpand {
  transition: 450ms all;
  transform-origin: center left;
  &:hover ~ .mobiVideoExpand {
    transform: translate3d(125px, 0, 0);
  }
}
/* .img_wrp {
  width: 200px;
  height: 200px;
} */
</style>



// WEBPACK FOOTER //
// src/components/mobiflix/Home.vue